import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IProjectBase } from '../models/IProjectInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Projects } from '../resources/Projects';
import { IResult } from '../ServerApi/types/IResponse';
import { IUserName } from '../ServerApi/types/IUser';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { IConfirmChangeOwnerScope } from './ContentActions';
import { ProjectErrors } from './ProjectErrors';
import { SearchSuggestionsService } from './SearchSuggestionsService';

export class ChangeProjectOwnerAction {

  public static $inject = ['ProjectErrors', 'ActionHelpers', 'ConfirmActionDialog', '$translate', 'Projects', 'SearchSuggestionsService'];

  constructor(
    private ProjectErrors: ProjectErrors,
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private Projects: Projects,
    private suggestions: SearchSuggestionsService) { }

  public confirmChangeOwner(projects: Set<IProjectBase>, context: IActionContext): ng.IPromise<IResult> {


    const ownerPicker = {
      prompt: projects.size() === 1
      ? this.$translate.instant('changeOwnerProjectPrompt', { NAME: L10n.elideIfLong(projects.first().name) })
      : this.$translate.instant('changeOwnerProjectsPrompt', { COUNT: projects.size() }, L10n.Interpolations.Count),
      ownerQuery: (matchText: string) => this.suggestions.usersCanOwnProject(matchText),
      targetOwner: <IUserName>null
    };
    const newDialogScope = <IConfirmChangeOwnerScope> context.scope.$new();
    newDialogScope.ownerPicker = ownerPicker;

    return this.ConfirmActionDialog.open({
      scope: newDialogScope,
      title: this.$translate.instant('changeOwner'),
      bodyTemplateUrl: 'changeOwnerDialog.html',
      actionName: this.$translate.instant('changeOwnerConfirm', { COUNT: projects.size() }, L10n.Interpolations.Count),

      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.Projects.setOwner(projects.keys(), ownerPicker.targetOwner.id)
          .then((result: IResult) => this.notifyResult(projects, result, ownerPicker.targetOwner.displayName));
      },
      confirmDisabled: () => !ownerPicker.targetOwner || !ownerPicker.targetOwner.id
    }).result.finally(() => newDialogScope.$destroy());
  }

  private notifyResult(projects: Set<IProjectBase>, result: IResult, ownerName: string) {
    this.ActionHelpers.notifyStandardError(
      projects,
      {
        successId: 'changeOwnerProjectsSuccess',
        errorId: 'changeOwnerProjectsError'
      },
      (errorItem: IErrorItem<IProjectBase>) => this.ProjectErrors.errorDetailsFor(errorItem),
      { OWNER_NAME: ownerName }
    )(result);
  }

}

Module.instance().service('ChangeProjectOwnerAction', ChangeProjectOwnerAction);
